import * as Sentry from '@sentry/nuxt';

export function reportError(message: string, error: any) {
  Sentry.withScope((scope) => {
    scope.setExtra('message', message);
    Sentry.captureException(error);
  });
}
